import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 32 32"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#fff",
      fillRule: "evenodd",
      d: "M25.69 1.263c4.448 1.728 5.477 6.646 5.477 6.646.664 2.758.863 5.582.83 8.107.033 2.493-.2 5.317-.864 8.108 0 0-1.028 4.918-5.476 6.646-2.09.83-5.907 1.196-9.657 1.23-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124c-.697-2.79-.896-5.615-.863-8.14-.033-2.493.2-5.317.863-8.109 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M.835 24h30.327l-.029.124s-1.028 4.918-5.476 6.646C23.567 31.6 19.75 31.966 16 32c-3.75-.034-7.567-.432-9.658-1.23C1.895 29.042.866 24.124.866 24.124z",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#E94B35",
      fillRule: "evenodd",
      d: "M.062 18.667h31.87a34 34 0 0 1-.272 2.666H.325a32 32 0 0 1-.263-2.666",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#227FBB",
      fillRule: "evenodd",
      d: "M31.997 16H.003v-.017c-.033-2.492.2-5.316.863-8.108 0 0 1.03-4.918 5.476-6.646C8.433.432 12.25.033 16 0c3.75.033 7.567.432 9.69 1.263 4.448 1.728 5.477 6.646 5.477 6.646.662 2.752.862 5.57.83 8.091",
      clipRule: "evenodd"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "#F2C500",
      fillRule: "evenodd",
      d: "m10.02 15.015.98-.682.98.682-.346-1.142.951-.721-1.193-.025L11 12l-.392 1.127-1.193.025.951.72zm3.118.376 1.193.025.392 1.127.392-1.127 1.193-.025-.951-.72.345-1.143-.98.682-.979-.682.346 1.142zm3.251 2.858-.95-.721 1.193-.024.391-1.128.392 1.127 1.194.025-.952.72.346 1.143-.98-.681-.98.681zm-.345 2.36.345 1.142-.95.721 1.193.024.391 1.128.392-1.127 1.194-.025-.952-.72.346-1.143-.98.681zm-1.713 3.975.392-1.127.392 1.127 1.193.025-.951.72.345 1.143-.98-.682-.979.682.346-1.142-.951-.721zm-2.351.401-.98.682-.98-.682.346 1.142-.951.721 1.193.025L11 28l.392-1.127 1.193-.025-.95-.72zm-4.31-.4 1.193.024-.952.72.346 1.143-.98-.682-.98.682.346-1.142-.95-.721 1.193-.025.391-1.127zm-1.108-2.113-.951-.72.345-1.143-.98.681-.979-.681.346 1.142-.951.721 1.193.024.392 1.128.392-1.127zM5.61 18.25l.345 1.142-.98-.681-.979.681.346-1.142-.951-.721 1.193-.024.392-1.128.392 1.127 1.193.025zm1.666-1.706.392-1.127 1.194-.025-.952-.72.346-1.143-.98.682-.98-.682.346 1.142-.95.721 1.193.025z",
      clipRule: "evenodd"
    }
  )
);
var SvgFlagCpv = styled(SvgComponent)`
  ${size}
  ${color}
`;
var FlagCpv_default = SvgFlagCpv;

export { FlagCpv_default as default };
